import api from "../axios";

// Get DB CART DATA
export const getCartDataDB = async () => {
  const apiData = api.post("/cart/getCartData");

  return apiData;
};

// ADD NEW PRODUCT
export const addToCartApi = async ({ data }) => {
  const apiData = await api.post("/cart/addcartagainstuser", {
    data: data,
  });

  return apiData;
};

export const syncLocalToDBCart = ({ data }) => {
  const apiData = api.post("/cart/synccartagainstuser", {
    data: data,
  });

  return apiData;
};

export const updateQtyAgainstProductDB = ({ product_id, qty }) => {
  const apiData = api.post("/cart/updateqtyagainstuser", {
    productId: product_id,
    Qty: qty,
  });

  return apiData;
};

export const deleteCartItemDB = async ({ product_id }) => {
  const apiData = await api.post("/cart/deletecartitems", {
    productId: product_id,
  });

  return apiData.data;
};
